export function FirstUpper(str) {
    let ind1 = str[0].toUpperCase()
    let restLetters = str.slice(1)
    const upperName = ind1 + restLetters
    return upperName
}